"use client"

import  React from "react"
import "@/components/Tabs/styles.css"
import {TabsTriggerProps} from "@/components/Tabs/model/TabsTriggerProps.tsx"
import {TabsProps} from "@/components/Tabs/model/TabsProps.tsx"
import {TabsListProps} from "@/components/Tabs/model/TabsListProps.tsx";
import {TabsContentProps} from "@/components/Tabs/model/TabsContentProps.tsx";

export const Tabs: React.FC<TabsProps> = ({children, className = ""}) => {
  return <div className={`tabs ${className}`}>{children}</div>
}

export const TabsList: React.FC<TabsListProps> = ({children, className = ""}) => {
  return <div className={`tabs-list ${className}`}>{children}</div>
}

export const TabsTrigger: React.FC<TabsTriggerProps> = ({children, active = false, onClick, className = ""}) => {
  return (
    <button onClick={onClick} className={`tab-trigger ${active ? "active" : ""} ${className}`}>
      {children}
    </button>
  )
}

export const TabsContent: React.FC<TabsContentProps> = ({children, className = ""}) => {
  return (
    <Tabs>
      <div className={`tab-content ${className}`}>{children}</div>
    </Tabs>
  )
}
